import { useMutation, useQuery } from '@apollo/client'
import { useState, useRef, useEffect } from 'react'
import { Flex, Box, Text, Heading, Button } from 'rebass/styled-components'
import { toast } from 'react-toastify';
import { SEND_SMS_TO_PATIENT } from '../graphql/mutations'
import { ISendSmsToPatientInput, ISendSmsToPatientOutput } from '../graphql/types/mutations/conversation'
import { IUser } from '../graphql/types/queries/user'
import withSession from '../lib/withSession'
import { TextAreaNoForm } from './TextArea';
import { IAppointment, IGetAppointmentsAndTicklersInput, IGetAppointmentsAndTicklersOutput } from '../graphql/types/queries/appointment';
import { GET_APPOINTMENTS_AND_TICKLERS } from '../graphql/queries';
import moment from 'moment';
import { Checkbox } from './CheckboxInput';
import { EnhancedModal } from './EnhancedModal';

interface ISendSmsProps {
  id: string
  name: string
  close: () => void
  defaultText?: string
  session: IUser
  patientId: string
}

const AppointmentDisplay = ({ appointment, onChange, selectedAppointment }: { appointment: IAppointment, onChange: (appointment: IAppointment) => void, selectedAppointment?: IAppointment | null }) => {
  return (
    <Flex onClick={() => onChange(appointment)} flexDirection={'column'} px={'24px'} py={'14px'} mb={2} style={{ border: '1px solid #344f79', background: !selectedAppointment || selectedAppointment.id !== appointment.id ? 'white' : '#93abd1', cursor: 'pointer' }}>
      <Text>{appointment.date} {appointment.startTime} {appointment.timezoneName}</Text>
      <Text>{appointment.provider.displayName}</Text>
    </Flex>
  )
}


const SelectAppointment = ({ appointments, onChange, selectedAppointment }: { appointments: Array<IAppointment>, onChange: (appointment: IAppointment) => void, selectedAppointment?: IAppointment | null }) => {
  console.log({ appointments })
  return (
    <Flex flexDirection={'column'} style={{ maxHeight: '70vh', overflowY: 'auto' }} px='12px'>
      <Heading>Pick Appointment Tied With SMS</Heading>
      {appointments.map(appt => {
        return (
          <AppointmentDisplay key={appt.id} appointment={appt} onChange={(a) => onChange(a)}
            selectedAppointment={selectedAppointment}
          />
        )
      })}
    </Flex>
  )
}

const SendSms: React.FC<ISendSmsProps> = ({ id, close, session, name, defaultText, patientId }) => {
  const [isParsingData, setIsParsingData] = useState<boolean>(false);
  const [attachToAppt, setAttachToAppt] = useState<boolean>(false);
  const [appointmentData, setAppointmentData] = useState<Array<IAppointment> | null>(null);
  const [isSelectAppointment, setIsSelectAppointment] = useState(false)
  const [selectedAppointment, setSelectedAppointment] = useState<IAppointment | null | undefined>()
  const [message, setMessage] = useState<string>(defaultText || `Hi. This is ${session.displayName} from Paloma Health. We are scheduled for a call right now. I will be calling back in just a few moments. I hope we connect today.`);
  const [note, setNote] = useState<string>();
  const [sendSms, { loading: loadingSendSms }] = useMutation<ISendSmsToPatientOutput, ISendSmsToPatientInput>(SEND_SMS_TO_PATIENT)
  const { data: dataApt, loading: loadingApt, error: errorApt } = useQuery<IGetAppointmentsAndTicklersOutput, IGetAppointmentsAndTicklersInput>(GET_APPOINTMENTS_AND_TICKLERS, {
    variables: {
      patientId: patientId || ''
    }
  })
  useEffect(() => {
    setIsParsingData(true)
    if (!!loadingApt || !dataApt || !dataApt.healthCoachGetAppointmentsAndTicklers) {
      return
    }
    setIsParsingData(true)

    let res: Array<IAppointment> = []

    for (let index = 0; index < dataApt.healthCoachGetAppointmentsAndTicklers.appointments.length; index++) {
      const element = dataApt.healthCoachGetAppointmentsAndTicklers.appointments[index];
      if (element.status === 'x') continue

      res.push({
        ...element,
      })
      // const fullDate = moment(`${element.date} ${element.startTime}`, 'MM/DD/YYYY HH:mm:ss')
      // let isFutureDate = moment().isBefore(fullDate)
      // if (!!isFutureDate && selectedPeriod === 'upcoming') {
      //   res.push({
      //     ...element,
      //     eventType: 'appointment'
      //   })
      // } else if (!isFutureDate && selectedPeriod === 'past') {
      //   res.push({
      //     ...element,
      //     eventType: 'appointment'
      //   })
      // }
    }

    let ordered = res.sort((a, b) => {
      let da = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm:ss')
      let db = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm:ss')

      if (moment(da).isBefore(db)) return 1
      return -1
    })

    setAppointmentData(ordered)
    setIsParsingData(false)
    console.log({ ordered })
    return () => {

    }
  }, [dataApt, loadingApt]);

  const toastId = useRef<any>(null);
  const _send = async () => {

    toastId.current = toast("Sending SMS", { autoClose: false, isLoading: true, closeButton: false });

    const res = await sendSms({
      variables: {
        id,
        message,
        appointmentId: selectedAppointment ? selectedAppointment.id : undefined,
        note: selectedAppointment && selectedAppointment.id && note ? note : undefined
      }
    })

    if (res && res.data && res.data.healthCoachSendSMS) {
      if (res.data.healthCoachSendSMS.ok) {
        toast.update(toastId.current, {
          render: 'SMS Sent!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        close()
      } else {
        toast.update(toastId.current, {
          render: res.data.healthCoachSendSMS.customError || 'An error occured',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    } else {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  }

  return (
    <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Heading mb={3}>Send SMS</Heading>
      <Text mb={4} >Send SMS to {name} - {id}</Text>
      <TextAreaNoForm
        autoFocus
        style={{ backgroundColor: 'white', flex: 1, minWidth: '430px', minHeight: '200px' }}
        placeholder='last name or patient id'
        onChange={(e: any) => setMessage(e.target.value)}
        value={message}

      />
      <Flex flexDirection={'column'} mt={3} mb={4}>
        {appointmentData && appointmentData.length > 0 && (
          <>
            <Checkbox isChecked={attachToAppt} onClick={() => setAttachToAppt(!attachToAppt)} label={'Attach to appointment'} />
            {!!attachToAppt && (
              <>
                {!selectedAppointment ? (
                  <Button variant={'primary'} style={{ height: 'fit-content', width: 'fit-content', padding: '4px 16px', fontSize: '12px' }} onClick={() => setIsSelectAppointment(true)}>Select appointment</Button>
                ) : (
                  <>
                    <AppointmentDisplay appointment={selectedAppointment} onChange={(a) => setIsSelectAppointment(true)} />

                    <TextAreaNoForm
                      style={{ backgroundColor: 'white', flex: 1, minWidth: '430px', minHeight: '200px', marginTop: '16px' }}
                      placeholder='Note to add to appointment'
                      onChange={(e: any) => setNote(e.target.value)}
                      value={note}
                    />
                  </>
                )}
              </>
            )}
          </>
        )}
      </Flex>
      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} disabled={!!loadingSendSms}>Cancel</Button>
        <Button variant={'primary'} onClick={_send} mt={4} disabled={!!loadingSendSms || !message || message.length < 2}>Send</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>

      <EnhancedModal
        containerStyle={{ paddingRight: 0, marginRight: 0 }}
        isOpen={!!isSelectAppointment}
        onClose={() => setIsSelectAppointment(false)}>
        <SelectAppointment appointments={appointmentData || []}
          onChange={appt => {
            setSelectedAppointment(appt)
            setIsSelectAppointment(false)
          }}
          selectedAppointment={selectedAppointment} />
      </EnhancedModal>
    </Box>);
}

export default withSession<ISendSmsProps>(SendSms)